import { render } from "./PlaceholderArt.vue?vue&type=template&id=be9d320a&scoped=true"
import script from "./PlaceholderArt.vue?vue&type=script&lang=js"
export * from "./PlaceholderArt.vue?vue&type=script&lang=js"

import "./PlaceholderArt.vue?vue&type=style&index=0&id=be9d320a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9d320a"]])

export default __exports__